import { SitePhotoType } from "./models/SitePhotoType";

export const SitePhotoTypes = {
    Preparation: { key: "Preparation", name: "Preparation stage" } as SitePhotoType,
    Issue: { key: "Issue", name: "Issue stage" } as SitePhotoType,
    WorkProgress: { key: "WorkProgress", name: "Work progress" } as SitePhotoType,
} as const;

export const getSitePhotoTypeByKey = (key: string): SitePhotoType | undefined => {
    return Object.values(SitePhotoTypes).find((type) => type.key === key);
};

const PreparationColor = "warning";
const IssueColor = "primary";
const WorkProgressColor = "secondary";

const sitePhotoService = {
    getSitePhotoTypeColor(key: string): string {
        if (key === SitePhotoTypes.Preparation.key) {
            return PreparationColor;
        }

        if (key === SitePhotoTypes.Issue.key) {
            return IssueColor;
        }

        if (key === SitePhotoTypes.WorkProgress.key) {
            return WorkProgressColor;
        }

        return "medium";
    },
};

export default sitePhotoService;
